import request from '@/router/axios';

const add = params => request({
  url: '/api/mcc-worker/infoequipment/save',
  method: 'post',
  params: {
    ...params,
  },
})

const getList = (current, size, params, deptId) => request({
  url: '/api/mcc-worker/infosalary/page',
  method: 'get',
  params: {
    ...params,
    current,
    size,
    deptId,
  },
})

const update = params => request({
  url: '/api/mcc-worker/infosalary/update',
  method: 'post',
  data: params,
})

export default {
  getList,
  update,
}
